module.exports = __webpack_public_path__ + "static/media/signal-icon3.03108055.svg";